import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";


export default {
    install: (app) => {
        app.config.globalProperties.$CookieConsent = CookieConsent;

        /** We had to make a change from the instruction of the vanilla cookie consent document.
         * We only show cookie consent banner when a test is not paid (show advertisement)
         * In order to do that, we will need to execute $CookieConsent.run(pluginConfig.cookieConsentConfig)
         * in App.js not here.
         * REF: https://cookieconsent.orestbida.com/essential/getting-started.html **/
        // app.config.globalProperties.$CookieConsent.run(pluginConfig.cookieConsentConfig);
    }
}